var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.todayIsBetweenDates(_vm.start, _vm.end))?_c('span',{staticClass:"todaybadge mr-2"},[_vm._v("\n    "+_vm._s(_vm.$t('vfair.activeNow'))+"\n")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }